module.exports = __webpack_public_path__ + "media/images/equipaments-e7e736329c11af7468c534093987f981.png";